import { cartAmountsReducer } from "~/features/addToCart/redux/cartAmounts/reducer";
import { srpReducer } from "~/features/search/redux/reducer";
import { cartPageReducer } from "~/features/cart/cart/redux/reducers/cartPageReducer";
import { checkoutPageReducer } from "~/features/cart/cart/redux/reducers/checkoutPageReducer";
import { cartReducer } from "~/features/cart/cart/redux/reducers/cartReducer";
import { globalMessagesReducer } from "~/features/toasts/redux/reducer";
import { productsReducer } from "~/domains/product/redux/reducer";
import { contractsReducer } from "~/features/contracts/redux/reducer";
import { productDetailsPageReducer } from "~/features/productDetails/redux/productDetailsReducer";
import navigationReducer from "~/features/navigation/redux/navigationSlice";
import { linearConfiguratorReducer } from "~/features/configurator/Linear/redux/reducer";
import { externalContentReducer } from "~/features/externalContent/redux/reducer";
import wishlistUIReducer from "~/features/wishlist/redux/wishlistSlice";

import { productComparisonReducer } from "~/features/compareProducts/redux/reducer";
import { regionSelectionBannerReducer } from "~/features/regionSelection/redux/reducer";
import { HOUSING_SA_REDUCER } from "~/features/selectionAssistant/housing/redux/reducer";
import { notificationsReducer } from "~/features/notifications/redux/NotificationsReducer";
import { saReducer } from "~/features/selectionAssistant/bearing/redux/reducer";
import { minicartReducer } from "~/features/cart/minicart/minicartRedux";
import { affiliateReducer } from "~/domains/affiliate/redux/reducer";
import { searchQueryReducer } from "~/features/search/redux/autosuggest/reducer";
import { navigationBreadcrumbsReducer } from "~/features/breadcrumbs/redux/reducer";
import type { Action, ThunkAction } from "@reduxjs/toolkit";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userPreferencesReducer from "~/domains/userPreferences/redux/userPreferencesSlice";
import { baseApi } from "~/app/store/baseApi";

const rootReducer = combineReducers({
  cartPage: cartPageReducer,
  checkoutPage: checkoutPageReducer,
  cart: cartReducer,
  globalMessages: globalMessagesReducer,
  products: productsReducer,
  cartAmounts: cartAmountsReducer,
  linearConfigurator: linearConfiguratorReducer,
  regionSelectionBanner: regionSelectionBannerReducer,
  navigationBreadcrumbs: navigationBreadcrumbsReducer,

  contracts: contractsReducer,
  wishlistUI: wishlistUIReducer,

  srp: srpReducer,
  pdp: productDetailsPageReducer,
  sa: saReducer,
  navigation: navigationReducer,

  externalContent: externalContentReducer,
  productComparison: productComparisonReducer,
  housingSA: HOUSING_SA_REDUCER,
  userPreferences: userPreferencesReducer,

  notifications: notificationsReducer,

  minicart: minicartReducer,

  affiliate: affiliateReducer,

  search: searchQueryReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    // @ts-expect-error
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware) as any,
  });
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, undefined, Action<string>>;
